import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getHiddenOptions, setHiddenOption } from "./api";

let cache = null;
const subs = new Set();
const publish = (d) => { cache = d; subs.forEach((f) => f(d)); };

export function useHiddenOptions(field) {
  const [all, setAll] = useState(cache || {});
  useEffect(() => {
    subs.add(setAll);
    getHiddenOptions().then(publish).catch(() => {});
    return () => subs.delete(setAll);
  }, []);
  const hidden = all[field] || [];
  const hide = async (value) => {
    publish({ ...all, [field]: [...hidden, value] });
    try {
      publish(await setHiddenOption(field, value));
      toast.success(`Removed “${value}” from suggestions`, { action: { label: "Undo", onClick: async () => publish(await setHiddenOption(field, value, true)) } });
    } catch {
      toast.error("Could not remove suggestion");
    }
  };
  return { visible: (values) => values.filter((v) => !hidden.includes(v)), hide };
}
